import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional } from '@angular/core';
import { BasketTotalsComponentDef, IBasketTotalsItem } from '@df/basket/view/basket-totals.component.def';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { Customer } from '@df/session/api/customer';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { CheckoutFormComponent } from '../../checkout/form/checkout-form.component';

declare module '@df/session/api/basket/basket' {
    interface IBasketTotals {
        discount_success_message?: string[];
        discounts_applied?: number;
    }
}

@Component({
    selector: 'basket-view-totals',
    templateUrl: './basket-view-totals.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, PriceComponent, TranslationModule]
})
export class BasketViewTotalsComponent extends BasketTotalsComponentDef {
    constructor(
        protected override changeDetectorRef: ChangeDetectorRef,
        protected override app: App,
        protected override customer: Customer,
        protected override timeoutService: TimeoutService,
        @Optional() protected checkoutFormComponent?: CheckoutFormComponent
    ) {
        super(changeDetectorRef, app, customer, timeoutService);
        this.subscriptions.add(
            this.app.events.on(Checkout.EVENTS.TotalsUpdate).subscribe(() => {
                this.update();
            })
        );
    }
    override get basket() {
        return (<CheckoutFormComponent>this.checkoutFormComponent)?.isSamples ? this.customer.samplesBasket : this.customer.basket;
    }
    protected override addCustomTotals(
        totals: IBasketTotalsItem[],
        totalsMap: {
            [totalId: string]: number;
        }
    ): void {
        const assembly = this.basket.data?.totals?.assembly;
        if (assembly) {
            totals.splice(totals.length - 1, 0, { label: 'Assemble Furniture', value: assembly, id: 'assembly' });
            totalsMap['assembly'] = assembly;
        }
    }

    itemLabel(item: IBasketTotalsItem): string {
        const successMessage = this.basket.totals.discount_success_message?.[0];
        return item.id === 'discount'
            ? (this.basket.totals.discounts_applied || 0) > 1
                ? 'Multiple discounts'
                : successMessage
                  ? successMessage
                  : item.label
            : item.label;
    }
}
